import { agentAvatarKind } from "@/lib/agent-avatar-kind";
import {
  workToastDisplayApps,
  workToastUsedComputer,
} from "@/lib/work-toast-apps";
import type { WorkToastItem } from "@/stores/work-toast-store";
import {
  WorkToastAppsLogo,
  WorkToastDenkerLogo,
  WorkToastProviderLogo,
} from "./work-toast-app-icons";
import {
  hasLiveComputerVisual,
  WorkToastLiveLogo,
} from "./work-toast-live-logo";

/** A coding session shows its coding app; other work shows the app it
 *  operates or Denker's avatar (see `agentAvatarKind`). */
export function WorkToastLogo({ item }: { item: WorkToastItem }) {
  const avatar = agentAvatarKind({
    codingProvider: item.codingProvider,
    hasApps: workToastDisplayApps(item).length > 0,
  });
  if (avatar.kind === "coding-cli") {
    return <WorkToastProviderLogo provider={avatar.cli} />;
  }
  if (workToastUsedComputer(item) && hasLiveComputerVisual(item)) {
    return <WorkToastLiveLogo item={item} />;
  }
  if (avatar.kind === "app") return <WorkToastAppsLogo item={item} />;
  // Every card that is not a coding session's is Denker's work: Denker's own
  // face on the project's colour, whatever the card's agent name or task.
  return <WorkToastDenkerLogo projectId={item.projectId} />;
}
